import React from "react";
import Select from "react-select";
import { Controller, Control } from "react-hook-form";

interface SelectOption {
  value: string;
  label: string;
}

interface FormSelectProps {
  label?: string;
  formFieldClassName?: string;
  name: string;
  control: Control<any>; // <-- add this
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  options: SelectOption[];
  error?: string;
  className?: string;
  required?: boolean;
  disabled?: boolean;
  defaultValue?: string | string[];
  isMulti?: boolean;
  required_asterik?: boolean;
}

const FormSelect: React.FC<FormSelectProps> = ({
  label,
  formFieldClassName,
  name,
  control,
  size,
  options,
  error,
  className,
  required,
  required_asterik,
  disabled,
  defaultValue,
  isMulti,
}) => {
  const getDefaultValue = () => {
    if (isMulti && Array.isArray(defaultValue)) {
      return options.filter((opt) => defaultValue.includes(opt.value));
    } else if (!isMulti && typeof defaultValue === "string") {
      return options.find((opt) => opt.value === defaultValue) || null;
    }
    return null;
  };

  return (
    <div
      className={`w-full max-lg:flex-col flex lg:items-center gap-2 ${formFieldClassName}`}
    >
      {label && (
        <label className="block text-[0.6rem] font-medium w-full lg:w-[200px]">
          {required || required_asterik ? (
            <span className="text-error">*</span>
          ) : (
            ""
          )}{" "}
          {label}
        </label>
      )}
      <div className="flex flex-col gap-2 flex-1 h-max w-full">
        <Controller
          control={control}
          name={name}
          defaultValue={getDefaultValue() as any}
          render={({ field }) => (
            <Select
              {...field}
              options={options}
              isDisabled={disabled}
              isMulti={isMulti}
              onChange={(option) => {
                field.onChange(
                  isMulti
                    ? (option as SelectOption[]).map((o) => o.value)
                    : (option as SelectOption)?.value
                );
              }}
              value={
                isMulti
                  ? options.filter((opt) =>
                      (field.value || []).includes(opt.value)
                    )
                  : options.find((opt) => opt.value === field.value) || null
              }
              className={`text-primary font-bold ${
                error ? "border-error" : ""
              } ${className}`}
              classNames={{
                control: () =>
                  `!border !border-primary !bg-base-100 ${
                    size === "xs"
                      ? "!min-h-[24px]"
                      : size === "sm"
                      ? "!min-h-[32px]"
                      : size === "md"
                      ? "!min-h-[36px]"
                      : size === "lg"
                      ? "!min-h-[40px]"
                      : size === "xl"
                      ? "!min-h-[44px]"
                      : "!min-h-[36px]"
                  } !min-h-0 !rounded-[0.5rem] !px-2 ${
                    error ? "!border-error" : ""
                  }`,
                valueContainer: () => "!p-0",
                input: () => "!p-0 !m-0",
                indicatorsContainer: () => "!h-full",
                dropdownIndicator: () => "!p-0 !m-0",
                clearIndicator: () => "!p-0 !m-0",
              }}
              isClearable
            />
          )}
        />
        {error && <p className="text-error text-xs mt-1">{error}</p>}
      </div>
    </div>
  );
};

export default FormSelect;
